import React, { useState } from "react";
import { Layout, Space } from "antd";
import CallForFacultyCards from "./CallForFacultyCards";
import { useQuery } from "@tanstack/react-query";
import { getUserFromId } from "../../api";
import { INTERNAL_LINKS } from "../../enum";
import HomePage from "../Home";
import { PrivateRoute } from "../../components";
import CallForFaculty from "./CallForFacultyCards/CallForFaculty";
import { Switch, useHistory } from "react-router-dom";
import FacultyCurrentDashboard from "./FacultyCurrentDashboard";
// import FacultyDashboardItem from "./FacultyCurrentDashboard/FacultyDashboardItem";
import FacultyPastDashboard from "./FacultyPastDashboard";
import FacultyDashboardItem from "./FacultyDashboardItem";
import httpClient from "../../api/module/httpClient";
import ProgramOpenForGuestLecturers from "./ProgramOpenForGuestLecturers";
import ProgramOpenForGuestLecturerItem from "./ProgramOpenForGuestLecturers/ProgramOpenForGuestLecturerItem";

const tabs = [
  {
    text: "My Faculty Dashboards",
    pathname: INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CURRENT,
  },
  {
    text: "Past Dashboards",
    pathname: INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_PAST,
  },
  {
    text: "Call for Faculty",
    pathname: INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_FACULTY_CARDS,
  },
];


export default function CertificateProgramFacultyDashboard() {
  const history = useHistory();
  const pathname = history.location.pathname;
  const [tab, setTab] = useState(2);

  const { data: userProfile } = useQuery({
    queryKey: ["USER_PROFILE"],
    queryFn: async () => {
      const { data } = await getUserFromId();

      return data.user;
    },
  });

  const { data: facultyCurrentDashboardData, isFetching: isFetchingFacultyCurrentDashboard } = useQuery({
    queryKey: ["MY_FACULTY_DASHBOARD", userProfile?.id],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate-programs/faculty/current-programs`);

      return data.filter(item => item.facilitatorIds.includes(userProfile?.id) || item.CertificateClassInstructors.some(instructor => instructor.UserId === userProfile?.id));
    },
    enabled: !!userProfile?.id,
  });

  const { data: pastDashboardData, isFetching: isFetchingPastDashboard } = useQuery({
    queryKey: ["MY_FACULTY_DASHBOARD_PAST", userProfile?.id],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate-programs/faculty/past-programs`);

      const filteredResults = data.filter(item => item.facilitatorIds.includes(userProfile?.id) || item.CertificateClassInstructors.some(instructor => instructor.UserId === userProfile?.id));

      return filteredResults;
    },
    enabled: !!userProfile?.id,
  });

  const { data: programsOpenForGuestLecturers } = useQuery({
    queryKey: ["CALL_FOR_GUEST_LECTURERS"],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate-programs/open-for-guest-lecturers`);

      return data;
    },
  });

  return (
    <div className="container-certificates" style={{ backgroundColor: "#FAFAFC", height: "calc(100vh - 72px)" }}>
      <Space>
        <>
          {(Array.isArray(facultyCurrentDashboardData) && facultyCurrentDashboardData.length > 0) && (
            <div
              className={
                tab === 0
                  ? "title-list-certificates"
                  : "title-list-certificates2"
              }
              onClick={() => {
                setTab(0);
                history.replace(INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CURRENT);
              }}
            >
              My Faculty Dashboards
            </div>
          )}
          {(Array.isArray(pastDashboardData) && pastDashboardData.length > 0) && (
            <div
              className={
                tab === 1
                  ? "title-list-certificates"
                  : "title-list-certificates2"
              }
              onClick={() => {
                setTab(1);
                history.replace(INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_PAST);
              }}
            >
              Past Dashboards
            </div>
          )}

          <div
            className={
              tab === 2
                ? "title-list-certificates"
                : "title-list-certificates2"
            }
            onClick={() => {
              setTab(2);
              history.replace(INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_FACULTY_CARDS);
            }}
          >
            Call for Faculty
          </div>
          {((programsOpenForGuestLecturers ?? []).length > 0 && ["lourencelinao13@gmail.com", "enrique@hackinghr.io"].includes(userProfile?.email)) && (
            <div
              className={
                tab === 3
                  ? "title-list-certificates"
                  : "title-list-certificates2"
              }
              onClick={() => {
                setTab(3);
                history.replace(INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_GUEST_LECTURERS);
              }}
            >
              Call for Guest Lectures
            </div>
          )}
        </>
      </Space>
      <Layout.Content>
        <Switch>
          <PrivateRoute
            path={INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CURRENT}
            exact
            render={(props) => <FacultyCurrentDashboard userProfile={userProfile} {...props} setTab={setTab}
                                                        data={facultyCurrentDashboardData}
                                                        isFetchingFacultyCurrentDashboard={isFetchingFacultyCurrentDashboard} />}
          />
          <PrivateRoute
            path={INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_PAST}
            exact
            render={(props) => <FacultyPastDashboard
              userProfile={userProfile}
              {...props}
              setTab={setTab}
              data={pastDashboardData}
              isFetching={isFetchingPastDashboard}
            />}
          />
          <PrivateRoute
            path={INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_FACULTY_CARDS}
            exact
            render={(props) => <CallForFacultyCards userProfile={userProfile} {...props} setTab={setTab} />}
          />
          <PrivateRoute
            path={`${INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_FACULTY}/:slug`}
            exact
            render={(props) => <CallForFaculty {...props} userProfile={userProfile} setTab={setTab} />}
          />

          <PrivateRoute
            path={`${INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_GUEST_LECTURERS}/:slug`}
            exact
            render={(props) => <ProgramOpenForGuestLecturerItem {...props} userProfile={userProfile} setTab={setTab} />}
          />
          <PrivateRoute
            path={`${INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CLASS}/:slug`}
            exact
            render={(props) => <FacultyDashboardItem {...props} userProfile={userProfile} setTab={setTab} />}
          />
          <PrivateRoute
            path={`${INTERNAL_LINKS.CERTIFICATE_PROGRAMS_FACULTY_DASHBOARD_CALL_FOR_GUEST_LECTURERS}`}
            exact
            render={(props) => <ProgramOpenForGuestLecturers
              userProfile={userProfile}
              {...props}
              setTab={setTab}
              data={programsOpenForGuestLecturers}
              isFetching={isFetchingPastDashboard}
            />}
          />
        </Switch>
      </Layout.Content>
    </div>
  );
}